import { auth, db, storage } from '../services/firebase';
import { 
  collection, 
  addDoc, 
  getDocs, 
  doc, 
  deleteDoc 
} from 'firebase/firestore';
import { 
  ref, 
  uploadBytes, 
  getDownloadURL, 
  deleteObject 
} from 'firebase/storage';

export const testFirebaseRules = async () => {
  const tests = {
    auth: {
      signup: false,
      login: false,
      logout: false
    },
    firestore: {
      read: false,
      write: false,
      delete: false
    },
    storage: {
      upload: false,
      download: false,
      delete: false
    },
    errors: []
  };

  try {
    // Test Authentication
    const testEmail = `test${Date.now()}@example.com`;
    const testPassword = 'Test123!';

    // Test signup
    try {
      const userCredential = await auth.createUserWithEmailAndPassword(testEmail, testPassword);
      tests.auth.signup = true;
      
      // Test login
      await auth.signInWithEmailAndPassword(testEmail, testPassword);
      tests.auth.login = true;

      // Test Firestore
      const testCollection = collection(db, 'test');
      
      // Test write
      const docRef = await addDoc(testCollection, {
        test: true,
        timestamp: new Date()
      });
      tests.firestore.write = true;

      // Test read
      const querySnapshot = await getDocs(testCollection);
      tests.firestore.read = querySnapshot.size >= 0;

      // Test delete
      await deleteDoc(doc(db, 'test', docRef.id));
      tests.firestore.delete = true;

      // Test Storage
      const testFile = new File(['test'], 'test.txt', { type: 'text/plain' });
      const storageRef = ref(storage, 'test/test.txt');

      // Test upload
      await uploadBytes(storageRef, testFile);
      tests.storage.upload = true;

      // Test download
      const url = await getDownloadURL(storageRef);
      tests.storage.download = !!url;

      // Test delete
      await deleteObject(storageRef);
      tests.storage.delete = true;

      // Test logout
      await auth.signOut();
      tests.auth.logout = true;

      // Cleanup test user
      await userCredential.user.delete();
    } catch (error) {
      tests.errors.push(`Auth test failed: ${error.message}`);
    }
  } catch (error) {
    tests.errors.push(`Test suite failed: ${error.message}`);
  }

  return tests;
}; 